module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"actions":{"back_to_my_duel":"Back to my Duel","change_email":"Change Email","change_password":"Change Password","change_username":"Change Username","rules_and_info":"Rules & Info","help":"Help","log_out":"Log Out"},"titles":{"log_out":"Log Out"},"messages":{"log_out_confirm":"You are going to leave the app. Are you sure?"}}}')
  delete Component.options._Ctor
}
